<div *ngIf="!isOnHold" class="container">
  <ng-container
    *ngTemplateOutlet="stepTemplate; context: { $implicit: steps[0] }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="arrowTemplate; context: { $implicit: isPast(steps[0]) }"
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="stepTemplate; context: { $implicit: steps[1] }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="arrowTemplate; context: { $implicit: isPast(steps[1]) }"
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="stepTemplate; context: { $implicit: steps[2] }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="arrowTemplate; context: { $implicit: isPast(steps[2]) }"
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="stepTemplate; context: { $implicit: steps[3] }"
  ></ng-container>
  <ng-container
    *ngTemplateOutlet="arrowTemplate; context: { $implicit: isPast(steps[3]) }"
  ></ng-container>

  <ng-container
    *ngTemplateOutlet="stepTemplate; context: { $implicit: steps[4] }"
  ></ng-container>
</div>

<div *ngIf="!isOnHold" class="container-descr">
  <div
    *ngFor="let step of steps"
    [class.cur]="isCur(step)"
    [class.past]="isPast(step)"
    [class.future]="isFuture(step)"
  >
    <p class="step-descr">{{ getStepDescr(step) }}</p>
  </div>
</div>

<div *ngIf="isOnHold" class="hold-container cur">
  <div class="hold-step">
    <div class="step">
      <img src="assets\img\tracker\In_waiting.svg" />
    </div>
  </div>
  <p class="step-descr">
    {{ "translate.tracker.onHold" | translate }}
  </p>
</div>

<ng-template #stepTemplate let-step>
  <div
    class="step-container"
    [class.cur]="isCur(step)"
    [class.past]="isPast(step)"
    [class.future]="isFuture(step)"
  >
    <div class="step">
      <img [src]="getIcon(step)" />
    </div>
  </div>
</ng-template>

<ng-template #arrowTemplate let-past>
  <div class="arrow-container">
    <img
      class="arrow"
      [src]="
        past
          ? 'assets\\img\\tracker\\angle-left.svg'
          : 'assets\\img\\tracker\\angle-left-grey.svg'
      "
    />
    <div class="line" [class.past]="past" [class.future]="!past"></div>
  </div>
</ng-template>
